module.exports = __webpack_public_path__ + "static/media/balance-budget-illustration.c7da6424.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/balance-budget-illustration.png
// module id = 301
// module chunks = 0